<template>
  <div class="bg-white py-12 px-20">
    <a
      :href="`https://${singleLandingPage.bannerUrl}`"
      @click="updateClientClickBanner"
    >
      <img
        class="w-full object-cover h-310px"
        :src="imageURL + singleLandingPage.bannerImage"
        alt="banner"
      />
    </a>
    <div class="mt-4 border-b pb-6">
      <h1 class="text-4xl text-2d3748 font-bold">
        {{ singleLandingPage.pageName }}
      </h1>
      <small class="text-sm text-2d3748 font-medium mt-2">{{
        new Date(singleLandingPage.createdAt).toDateString()
      }}</small>
    </div>
    <div class="mt-4">
      <p
        class="text-md text-2d3748 font-medium mt-2"
        v-html="singleLandingPage.content"
      ></p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      singleLandingPage: {},
    };
  },
  methods: {
    async loadData() {
      let filteredURL = window.document.location.href.split("=");
      const payload = {
        shortURL: filteredURL[1],
      };
      const { data } = await this.$store.dispatch(
        "landingPage/getSingle",
        payload
      );
      this.singleLandingPage = data;
      const opens = {
        id: this.singleLandingPage._id,
        clicks: this.singleLandingPage.clicks + 1,
      };
      await this.$store.dispatch("landingPage/updateOpens", opens);
    },
    async updateClientClickBanner() {
      const opens = {
        id: this.singleLandingPage._id,
        bannerUrlClicks: this.singleLandingPage.bannerUrlClicks + 1,
      };
      await this.$store.dispatch("landingPage/updateOpens", opens);
    },
  },
  async mounted() {
    this.loadData();
  },
  computed: {
    imageURL() {
      return process.env.VUE_APP_IMAGE_URL;
    },
  },
};
</script>
